// extracted by mini-css-extract-plugin
export default {"link":"_4qzrfpqXKz","link-active":"d2qljuE1Fp","linkActive":"d2qljuE1Fp","icon":"sSAtKcI++A"};